import StimulusReflex from 'stimulus_reflex'
import awaitEvent from '../helpers/awaitEvent'
import { application } from './stimulus'
import consumer from '../channels/consumer'

StimulusReflex.initialize(application, { consumer, debug: true })

export default StimulusReflex
